type ErrorMessages = {
  required: string;
  invalid: string;
  lengthExceeded: string;
};

export const validateName = (value: string, errorMessages: ErrorMessages) => {
  const regex = /^[A-Za-z\u00C0-\u024F\s']+$/;
  if (!value) return errorMessages.required;
  if (!regex.test(value)) return errorMessages.invalid;
  if (value.length > 50) return errorMessages.lengthExceeded;
  return '';
};

export const validatePhone = (value: string, errorMessages: ErrorMessages) => {
  const regex = /^\+?\d+$/;
  if (!value) return errorMessages.required;
  if (!regex.test(value)) return errorMessages.invalid;
  if (value.length > 15) return errorMessages.lengthExceeded;
  return '';
};

type EmailErrorMessages = Omit<ErrorMessages, 'lengthExceeded'>;

export const validateEmail = (
  value: string,
  errorMessages: EmailErrorMessages
) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!value) return errorMessages.required;
  if (!emailRegex.test(value)) return errorMessages.invalid;
  return '';
};

export const validatePassword = (password: string) => {
  const minLength = password.length >= 7;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /\d/.test(password);
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return { minLength, hasUppercase, hasLowercase, hasNumber, hasSpecialChar };
};
